<template>
    <div>
        <div class="md-layout">
            <div class="md-layout-item md-size-100 container-buttons">
                <div class="button-checkbox" :class="{ active: isCustomer }" @click="customerCheckbox">
                    <span>Customer</span>
                </div>

                <div class="button-checkbox" :class="{ active: isDriver }" @click="driverCheckbox">
                    <span>Team Member</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdjustmentStep',
    props: {
        adjustmentDetails: {
            type: Object,
            default: () => {}
        },
        showCustomer: {
            type: Boolean,
            default: false
        },
        showDriver: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isCustomer: false,
            isDriver: false
        };
    },
    mounted() {
        this.isCustomer = this.adjustmentDetails.isCustomer || this.showCustomer;
        this.isDriver = this.adjustmentDetails.isDriver || this.showDriver;
    },
    watch: {
        isCustomer() {
            this.$emit('isCustomer', this.isCustomer);
        },
        isDriver() {
            this.$emit('isDriver', this.isDriver);
        },
        'adjustmentDetails.isDriver': function(newVal, oldVal) {
            this.isDriver = this.adjustmentDetails.isDriver;
        },
        'adjustmentDetails.isCustomer': function(newVal, oldVal) {
            this.isCustomer = this.adjustmentDetails.isCustomer;
        }
    },
    methods: {
        customerCheckbox() {
            this.isCustomer = !this.isCustomer;
            this.isDriver = !this.isCustomer;
        },
        driverCheckbox() {
            this.isDriver = !this.isDriver;
            this.isCustomer = !this.isDriver;
        }
    }
};
</script>

<style lang="scss" scoped>
.container-buttons {
    text-align-last: center !important;
}

.button-checkbox {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    border-radius: 5px;
    margin: 10px;
    cursor: pointer;
    background-color: #ccc;
    color: #fff;
    transition: background-color 0.3s ease, transform 0.2s ease;
    user-select: none;
    width: 250px;
    height: 80px;
}

.button-checkbox.active {
    background-color: #4caf50;
}

.button-checkbox:hover {
    transform: scale(1.05);
}

.button-checkbox:active {
    transform: scale(0.95);
}
</style>
